import { useLazyQuery, useQuery } from "@apollo/client/react"; import { useState, useMemo, useEffect } from "react";

import { Box, CircularProgress, Grid } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { EmptyState } from "../../../../components/EmptyState/EmptyState";
import DataGridGenerico from "../../../../components/dataGrid/DataGridGenerico";
import { TabMonitoreoHeader } from "../components/TabMonitoreo/TabMonitoreoHeader";
import { MonitoreoDialog } from "../components/TabMonitoreo/MonitoreoDialog";
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import { GET_PROFESIONAL_MONITOREOS } from '../../../../data/graphQL/queries/Profesionales/getProfesionalMonitoreos';
import { adaptProfesionalMonitoreoCombos, GET_PROFESIONAL_MONITOREO_COMBOS } from '../../../../data/graphQL/queries/Profesionales/getProfesionalMonitoreoCombos';
import moment from "moment";
import { PopoverModal } from "../../../../components/popoverModal/PopoverModal";
import { ClasificacionMonitoreoDialog } from "../components/TabMonitoreo/ClasificacionMonitoreoDialog";
import ThumbsUpDownOutlinedIcon from '@mui/icons-material/ThumbsUpDownOutlined';
import { CustomChip } from "../../../../components/chip/Chip";


const ESTADO_PENDIENTE = 1;
const ESTADO_APROBADO = 2;
const ESTADO_RECHAZADO = 3;

export const TabMonitoreo = ({
  profesionalLoading,
  monitoreoFormData,
  setMonitoreoFormData,
  idProfesional,
  reclamos
}) => {
  const [areThereMonitoreo, setAreThereMonitoreo] = useState(false);
  const [monitoreos, setMonitoreos] = useState([]);
  const [monitoreoSelected, setMonitoreoSelected] = useState(null);
  const [viewMonitoreo, setViewMonitoreo] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogClasificacion, setOpenDialogClasificacion] = useState(false);
  const [profesionalMonitoreoCombos, setProfesionalMonitoreoCombos] = useState([]);

  const getChipEstado = (estado) => {
    switch (estado) {
      case ESTADO_PENDIENTE:
        return (
          <CustomChip label='Pendiente' isYellow title='Pendiente' />);

      case ESTADO_APROBADO:
        return (
          <CustomChip label='Aprobado' isGreen title='Aprobado' />);

      case ESTADO_RECHAZADO:
        return (
          <CustomChip label='Rechazado' isRed title='Rechazado' />);

      default: return;
    }
  };


  const [fetchProfesionalMonitoreos, { data: monitoreosData }] = useLazyQuery(GET_PROFESIONAL_MONITOREOS, {
    fetchPolicy: 'no-cache',
    variables: { idProfesional }
  });

  const getProfesionalMonitoreo = () => {
    if (idProfesional) {
      fetchProfesionalMonitoreos({
        variables: { idProfesional }
      });
    }
  };

  useEffect(() => {
    getProfesionalMonitoreo();
  }, [idProfesional]);

  useEffect(() => {
    if (monitoreosData?.profesionalMonitoreos) {
      setMonitoreos(monitoreosData.profesionalMonitoreos);
    }
  }, [monitoreosData]);

  const { data: dataProfesionalMonitoreoCombos } = useQuery(GET_PROFESIONAL_MONITOREO_COMBOS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataProfesionalMonitoreoCombos) return;
    const combosAdapted = adaptProfesionalMonitoreoCombos(dataProfesionalMonitoreoCombos.profesionalMonitoreoCombos);
    setProfesionalMonitoreoCombos(combosAdapted);
  }, [dataProfesionalMonitoreoCombos]);

  useEffect(() => {
    setAreThereMonitoreo(monitoreos.length > 0);
  }, [monitoreos]);

  const loadingPage = useMemo(() => {
    return profesionalLoading;
  }, [profesionalLoading]);

  if (loadingPage) return <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '20vh'
    }}>

    <CircularProgress size={40} />
  </Box>;

  const handleClickView = (row) => {
    setMonitoreoSelected(row);
    setOpenDialog(true);
    setViewMonitoreo(true);
  };

  const handleClickClasificacion = (row) => {
    setOpenDialogClasificacion(true);
    setMonitoreoSelected(row);
  };

  const handleClickAgregar = () => {
    setMonitoreoSelected(null);
    setOpenDialog(true);
    setViewMonitoreo(false);
  };


  const columns = generateColumnsDefaultConfiguration([
    {
      headerName: '',
      field: 'accion',
      flex: 20,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal closeOnClick>
              <div className='popover-modal-content'>
                <div onClick={() => handleClickView(row)} aria-hidden='true' className='item-option clickable-option'>
                  <VisibilityIcon className='edit-icon' />
                  <span className='toggle-action'>Ver</span>
                </div>
                {row.idProfesionalMonitoreo === monitoreos[0]?.idProfesionalMonitoreo &&
                  <div
                    onClick={() => !row.profesionalMonitoreoSugerencia[0]?.idEstadoNavigation?.idEstadoProfesionalMonitoreoSugerencia && handleClickClasificacion(row)} aria-hidden='true'
                    className={`item-option ${!!row.profesionalMonitoreoSugerencia[0]?.idEstadoNavigation?.idEstadoProfesionalMonitoreoSugerencia ? 'disabled-option' : 'clickable-option'}`}>

                    <ThumbsUpDownOutlinedIcon className='edit-icon' />
                    <span className='toggle-action'>Clasificación</span>
                  </div>}
              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      headerName: '#',
      field: 'idProfesionalMonitoreo',
      flex: 50
    },
    {
      headerName: 'Fecha',
      field: 'fechaMonitoreo',
      type: 'datetime',
      flex: 120,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div>
            {moment(row.fechaMonitoreo).format('DD/MM/YYYY HH:mm')}
          </div>);
      }
    },
    {
      headerName: 'Reclamos',
      field: 'reclamos',
      type: 'string',
      flex: 170,
      renderCell: (cellProps) => {
        const { row } = cellProps;

        return (
          <div>
            {row.idProfMonitoreoReclamoNavigation?.descripcion}
          </div>);
      }
    },
    {
      headerName: 'Visitas',
      field: 'visitas',
      type: 'string',
      flex: 100,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div>
            {row.idProfMonitoreoVisitasNavigation?.descripcion}
          </div>);
      }
    },
    {
      headerName: 'Completitud',
      field: 'completitud',
      type: 'string',
      flex: 120,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div>
            {row.idProfMonitoreoCompletitudNavigation?.descripcion}
          </div>);
      }
    },
    {
      headerName: 'Entrenamiento',
      field: 'entrenamiento',
      type: 'string',
      flex: 180,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div>
            {row.idProfMonitoreoEntrenamientoNavigation?.descripcion}
          </div>);
      }
    },
    {
      headerName: 'Usuario',
      field: 'usuario',
      type: 'string',
      flex: 100,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div>
            {row.idUsuarioNavigation?.nombre + " " + row.idUsuarioNavigation?.apellido}
          </div>);
      }
    },
    {
      headerName: 'Clase',
      field: 'clase',
      type: 'string',
      flex: 100,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div>
            {row.idClaseMonitoreoNavigation?.descripcion}
          </div>);
      }
    },
    {
      headerName: 'Solicitud',
      field: 'solicitud',
      type: 'string',
      flex: 100,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div>
            {row.profesionalMonitoreoSugerencia[row.profesionalMonitoreoSugerencia.length - 1]?.idClaseMonitoreoSugerenciaNavigation?.descripcion || '-'}
          </div>);
      }
    },
    {
      headerName: 'Estado',
      field: 'estado',
      type: 'string',
      flex: 100,
      align: 'center',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div>
            {getChipEstado(row.profesionalMonitoreoSugerencia[0]?.idEstadoNavigation?.idEstadoProfesionalMonitoreoSugerencia)}
          </div>);
      }
    }],
    true);

  return (
    <div className='generic-tab-container'>
      <MonitoreoDialog
        open={openDialog}
        profesionalMonitoreoCombos={profesionalMonitoreoCombos}
        handleCloseDialog={() => setOpenDialog(false)}
        readOnly={viewMonitoreo}
        monitoreoSelected={monitoreoSelected}
        monitoreos={monitoreos}
        idProfesional={idProfesional}
        fetchProfesionalMonitoreos={getProfesionalMonitoreo}
        reclamos={reclamos}
        fechaProximoMonitoreo={monitoreoFormData?.fechaProximoMonitoreo} />

      <ClasificacionMonitoreoDialog
        open={openDialogClasificacion}
        handleCloseDialog={() => setOpenDialogClasificacion(false)}
        monitoreoSelected={monitoreoSelected}
        fetchProfesionalMonitoreos={getProfesionalMonitoreo} />

      <Grid container className='patient-card'>
        <Grid container spacing={2} size={{ xs: 12 }}>
          <Grid size={{ xs: 12, md: 2.5 }}>
            <div className='patient-card-label'>F. Ultimo monitoreo</div>
            <div>{!!monitoreos[0]?.fechaMonitoreo ?
              moment(monitoreos[0]?.fechaMonitoreo).format('DD/MM/YYYY HH:mm') :
              "-"}</div>
          </Grid>
          <Grid size={{ xs: 12, md: 2.5 }}>
            <div className='patient-card-label'>F. Próximo monitoreo</div>
            <div>
                {monitoreos?.[0]?.idProfesionalNavigation?.fechaProximoMonitoreo
                  ? moment(monitoreos[0].idProfesionalNavigation.fechaProximoMonitoreo).format('DD/MM/YYYY HH:mm')
                  : !!monitoreoFormData?.fechaProximoMonitoreo
                    ? moment(monitoreoFormData.fechaProximoMonitoreo).format('DD/MM/YYYY HH:mm')
                    : "-"
                }
               </div>
          </Grid>
          <Grid size={{ xs: 12, md: 2.5 }}>
            <div className='patient-card-label'>Resultado monitoreo</div>
            <div>{monitoreos[0]?.idProfMonitoreoResultadoNavigation?.descripcion || '-'}</div>
          </Grid>
          <Grid size={{ xs: 12, md: 2.5 }}>
            <div className='patient-card-label'>Puntaje</div>
            <div>{monitoreos[0]?.puntosResultado || '-'}</div>
          </Grid>
          <Grid size={{ xs: 12, md: 2 }}>
            <div className='patient-card-label'>Clase</div>
            <div>{monitoreos[0]?.idProfesionalNavigation?.idClaseMonitoreoNavigation?.descripcion || '-'}</div>
          </Grid>
        </Grid>
      </Grid>
      {areThereMonitoreo ?
        <Box>
          <TabMonitoreoHeader setOpenDialog={handleClickAgregar}
            ultimoEstadoPendiente={monitoreos[0]?.profesionalMonitoreoSugerencia[0]?.idEstadoNavigation?.idEstadoProfesionalMonitoreoSugerencia === ESTADO_PENDIENTE} />

          <DataGridGenerico
            columns={columns}
            totalCount={monitoreos.length}
            rows={monitoreos}
            toolbar={false}
            // loading={loadingEvaluacionProfesional}
            maxWidth={columns.reduce((total, column) => total + (column.width || 0), 0)} />

        </Box> :

        <EmptyState
          text={"No se ha agregado ningún Monitoreo"}
          buttonText={"Agregar Monitoreo"}
          onClick={() => handleClickAgregar()} />

      }
    </div>);

};